// src/admin/AdminDashboard.js
import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AdminHome from "./AdminHome";

function AdminDashboard() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`flex bg-gray-100 min-h-screen ${
        isOpen ? "overflow-hidden lg:overflow-auto" : ""
      }`}
    >
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="flex-1 lg:ml-64 transition-all duration-300">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6">
          <AdminHome />
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;
